import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import { TIME_DUE_FORMAT, DUE_DATE_FORMAT } from 'enums/date-format-enums';
import { SHIPPED_BUYER, SOLD, SELLER_PACKAGING } from 'enums/order-state-enums';
import { COLORS } from 'styles/theme/colors';

export const DateDisplay = ({ date, completed, status }) => {
  let isToday;
  let dayToConfirmBy;
  let isPassed;
  let time;
  let displayDate;

  if (date) {
    if (status === SOLD) {
      dayToConfirmBy = moment(date).add(1, 'days');
      isToday = moment().isSame(dayToConfirmBy, 'day');
      isPassed = moment().isAfter(dayToConfirmBy);
      time = moment(dayToConfirmBy).format(TIME_DUE_FORMAT);
      displayDate = moment(dayToConfirmBy).format(DUE_DATE_FORMAT);
    } else {
      isToday = moment().isSame(date, 'day');
      isPassed = moment().isAfter(date);
      time = moment(date).format(TIME_DUE_FORMAT);
      displayDate = moment(date).format(DUE_DATE_FORMAT);
    }
  }
  return (
    <React.Fragment>
      {date ? (
        <DateDisplay.StyledDateDisplay
          isToday={isToday || (isPassed && status !== SHIPPED_BUYER)}
          isCompleted={completed}
        >
          {isToday && !completed && status !== SELLER_PACKAGING && status !== SHIPPED_BUYER
            ? `Due Today @ ${time}`
            : displayDate}
        </DateDisplay.StyledDateDisplay>
      ) : (
        <DateDisplay.Dash />
      )}
    </React.Fragment>
  );
};

DateDisplay.StyledDateDisplay = styled.div`
  color: ${(props) =>
    props.isToday && !props.isCompleted ? COLORS.primaryErrorText : COLORS.primaryText};
`;

DateDisplay.Dash = styled.div`
  border-bottom: 1px solid ${COLORS.primaryDash};
  width: 60px;
`;

DateDisplay.propTypes = {
  date: PropTypes.string.isRequired,
  completed: PropTypes.bool,
  status: PropTypes.string,
};

export default DateDisplay;
